(function() {
    'use strict';

    angular
        .module('liverunApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('promo-code', {
            parent: 'entity',
            url: '/promo-code',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'liverunApp.promoCode.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/promo-code/promo-codes.html',
                    controller: 'PromoCodeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('promoCode');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('promo-code-detail', {
            parent: 'promo-code',
            url: '/promo-code/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'liverunApp.promoCode.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/promo-code/promo-code-detail.html',
                    controller: 'PromoCodeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('promoCode');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PromoCode', function($stateParams, PromoCode) {
                    return PromoCode.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'promo-code',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('promo-code-detail.edit', {
            parent: 'promo-code-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/promo-code/promo-code-dialog.html',
                    controller: 'PromoCodeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PromoCode', function(PromoCode) {
                            return PromoCode.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('promo-code.new', {
            parent: 'promo-code',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/promo-code/promo-code-dialog.html',
                    controller: 'PromoCodeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                englishDescription: null,
                                japaneseDescription: null,
                                toWho: null,
                                totalTimesUsed: null,
                                usageLimit: null,
                                endTrialInDays: null,
                                productId: null,
                                expirationDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('promo-code', null, { reload: 'promo-code' });
                }, function() {
                    $state.go('promo-code');
                });
            }]
        })
        .state('promo-code.edit', {
            parent: 'promo-code',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/promo-code/promo-code-dialog.html',
                    controller: 'PromoCodeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PromoCode', function(PromoCode) {
                            return PromoCode.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('promo-code', null, { reload: 'promo-code' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('promo-code.delete', {
            parent: 'promo-code',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/promo-code/promo-code-delete-dialog.html',
                    controller: 'PromoCodeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PromoCode', function(PromoCode) {
                            return PromoCode.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('promo-code', null, { reload: 'promo-code' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
